export const lerp = (min, max, value) => {
    return value * (max - min) + min;
};

export const lerpExt = (min, max, value, multiplier, precision) => {
    let result = lerp(0, max - min, value);
    result = Math.round(result / multiplier) * multiplier;
    return parseFloat((min + result).toFixed(precision));
};
